module.exports = __webpack_public_path__ + "static/img/fz_lcb_tb.50dc6b2.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/fz_lcb_tb.png
// module id = kcup
// module chunks = 0